// extracted by mini-css-extract-plugin
module.exports = {"container":"MFooter_container__1mYc-","title":"MFooter_title__JWcMI"};